import { render } from "./RecentSearches.vue?vue&type=template&id=2d88803c"
import script from "./RecentSearches.vue?vue&type=script&lang=js"
export * from "./RecentSearches.vue?vue&type=script&lang=js"

import "./RecentSearches.vue?vue&type=style&index=0&id=2d88803c&lang=css"

import exportComponent from "C:\\Users\\kiemp\\OneDrive\\Documents\\VSCode\\SMM2_info\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__